var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse("{\"name\":\"simple-calendar\",\"version\":\"0.2.6\",\"description\":\"Simple calendar to make one entry per day\",\"keywords\":[\"calendar\",\"simple\"],\"license\":\"ISC\",\"author\":\"https://kamal.morjal.com\",\"scripts\":{\"dev\":\"parcel src/index.pug\",\"build\":\"parcel build src/index.pug\",\"cachebust\":\"rm -rf .parcel-cache && rm -rf dist\",\"test\":\"echo \\\"Error: no test specified\\\" && exit 1\"},\"devDependencies\":{\"@parcel/transformer-pug\":\"^2.16.4\",\"@parcel/transformer-sass\":\"^2.16.4\",\"parcel\":\"^2.16.4\"}}");


const $bd59b245239a9d43$export$d26a8f3a62acd81 = 'Simple Calendar';
const $bd59b245239a9d43$export$7f06b53a0b6713fe = (0, $8f13b60c0ee5b277$exports.version);
const $bd59b245239a9d43$export$a2da6b09a9b1a5a4 = 'beta';
const $bd59b245239a9d43$export$d4298899e36f1e15 = 'https://kamal.morjal.com';


function $4b591140bf88a301$export$2e2bcd8739ae039(date) {
    // sanitize our d/m/yyyy date string to d/mm/yyyy
    const split_d = date.split('/');
    split_d[1] = split_d[1].padStart(2, '0');
    // for future use
    // const formattedDate = new Date(date);
    // const year = formattedDate.getFullYear();
    // const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
    // const day = String(formattedDate.getDate()).padStart(2, '0');
    // return `${year}-${month}-${day}`;
    return split_d.join('/');
}


console.log(`main.js loaded`);
let $ad2bcec7a0192558$var$app_state = {};
// Element cache
const $ad2bcec7a0192558$var$calendar = document.querySelector('#calendar');
const $ad2bcec7a0192558$var$monthNameDisplay = document.querySelector('#monthNameDisplay');
const $ad2bcec7a0192558$var$weekdaysContainer = document.querySelector('#weekdays');
const $ad2bcec7a0192558$var$newEventModal = document.querySelector('#newEventModal');
const $ad2bcec7a0192558$var$viewEventModal = document.querySelector('#viewEventModal');
const $ad2bcec7a0192558$var$aboutModal = document.querySelector('#aboutModal');
const $ad2bcec7a0192558$var$backdrop = document.querySelector('#modalBackDrop');
const $ad2bcec7a0192558$var$aboutButton = document.querySelector('#aboutButton');
const $ad2bcec7a0192558$var$eventTitleInput = document.querySelector('#eventTitleInput');
const $ad2bcec7a0192558$var$eventDetailsInput = document.querySelector('#eventDetailsInput');
// Done element cache
const $ad2bcec7a0192558$var$weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
const $ad2bcec7a0192558$var$months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
$ad2bcec7a0192558$var$app_state.nav = 0;
$ad2bcec7a0192558$var$app_state.clicked = null;
$ad2bcec7a0192558$var$app_state.events = localStorage.getItem('events') ? JSON.parse(localStorage.getItem('events')) : [];
function $ad2bcec7a0192558$var$sanitizeData() {
    console.info(`Sanitizing all event data`);
    $ad2bcec7a0192558$var$app_state.events.forEach((event)=>{
        event.date = (0, $4b591140bf88a301$export$2e2bcd8739ae039)(event.date);
    });
    console.info(`Sanitizing data complete`);
}
function $ad2bcec7a0192558$var$logAllData() {
    console.info(`Simple Calendar v: ${(0, $bd59b245239a9d43$export$7f06b53a0b6713fe)}`);
    console.table($ad2bcec7a0192558$var$app_state.events, [
        "date",
        "title",
        "details"
    ]);
}
function $ad2bcec7a0192558$var$cleanup() {
    $ad2bcec7a0192558$var$calendar.innerHTML = '';
    $ad2bcec7a0192558$var$monthNameDisplay.innerHTML = '';
    $ad2bcec7a0192558$var$weekdaysContainer.innerHTML = '';
}
function $ad2bcec7a0192558$var$openAboutModal() {
    $ad2bcec7a0192558$var$aboutModal.style.display = 'block';
    $ad2bcec7a0192558$var$backdrop.style.display = 'block';
    $ad2bcec7a0192558$var$logAllData();
}
function $ad2bcec7a0192558$var$closeAboutModal() {
    $ad2bcec7a0192558$var$aboutModal.style.display = 'none';
    $ad2bcec7a0192558$var$backdrop.style.display = 'none';
}
function $ad2bcec7a0192558$var$openModal(date) {
    $ad2bcec7a0192558$var$backdrop.style.display = 'block';
    //--- modal wrangling done.
    const eventTitle = document.querySelector('#eventTitle');
    const eventDetails = document.querySelector('#eventDetails');
    $ad2bcec7a0192558$var$app_state.clicked = date;
    // app_state.clicked is the date that was clicked, or null if no date was clicked.
    // This is useful for setting the modal content based on the date.
    // For example, if a date is clicked, we can pre-fill the modal with
    // the date information, such as the day, month, and year.
    // If no date is clicked, we can leave the modal empty or set it to
    // the current date.
    const DAY_EVENT_EXISTS = $ad2bcec7a0192558$var$app_state.events.find((event)=>event.date === $ad2bcec7a0192558$var$app_state.clicked);
    if (DAY_EVENT_EXISTS) {
        console.log(`Event on date: ${$ad2bcec7a0192558$var$app_state.clicked}`);
        // If an event exists for the clicked date...
        // for now, just close the modal and sheepishly look away
        const viewEventTitle = document.querySelector('#viewEventTitle');
        const viewEventDetails = document.querySelector('#viewEventDetails');
        const viewEventDate = document.querySelector('#viewEventDate');
        viewEventDate.innerText = DAY_EVENT_EXISTS.date; // Display the event date
        viewEventTitle.innerText = DAY_EVENT_EXISTS.title; // Display the event title
        viewEventDetails.innerText = DAY_EVENT_EXISTS.details; // Display the event details
        $ad2bcec7a0192558$var$viewEventModal.style.display = 'block';
        $ad2bcec7a0192558$var$backdrop.style.display = 'block';
    // closeModal();
    } else {
        $ad2bcec7a0192558$var$newEventModal.style.display = 'block';
        eventTitle.innerText = `Add Event`;
        eventDetails.innerText = `Date: ${date}.`;
    // console.log('Modal opened');
    }
}
function $ad2bcec7a0192558$var$closeModal() {
    $ad2bcec7a0192558$var$newEventModal.style.display = 'none';
    $ad2bcec7a0192558$var$viewEventModal.style.display = 'none';
    $ad2bcec7a0192558$var$backdrop.style.display = 'none';
    $ad2bcec7a0192558$var$eventTitleInput.value = '';
    $ad2bcec7a0192558$var$eventDetailsInput.value = '';
    $ad2bcec7a0192558$var$app_state.clicked = null; // Reset clicked date
    // console.log('Modal closed');
    $ad2bcec7a0192558$var$load();
}
function $ad2bcec7a0192558$var$saveEvent() {
    // Save the event to localStorage
    const title = $ad2bcec7a0192558$var$eventTitleInput.value?.trim();
    const details = $ad2bcec7a0192558$var$eventDetailsInput.value?.trim();
    const date = $ad2bcec7a0192558$var$app_state.clicked;
    if (title && details && date) {
        $ad2bcec7a0192558$var$eventTitleInput.classList.remove('error');
        $ad2bcec7a0192558$var$eventDetailsInput.classList.remove('error');
        const event = {
            title: title,
            details: details,
            date: date
        };
        $ad2bcec7a0192558$var$app_state.events.push(event);
        localStorage.setItem('events', JSON.stringify($ad2bcec7a0192558$var$app_state.events));
        $ad2bcec7a0192558$var$closeModal();
    } else {
        if (!title) $ad2bcec7a0192558$var$eventTitleInput.classList.add('error');
        if (!details) $ad2bcec7a0192558$var$eventDetailsInput.classList.add('error');
        console.error('Please fill in all fields before saving the event.');
    }
}
function $ad2bcec7a0192558$var$deleteEvent(date) {
    // Delete the event from localStorage
    const eventIndex = $ad2bcec7a0192558$var$app_state.events.findIndex((event)=>event.date === date);
    if (eventIndex !== -1) {
        $ad2bcec7a0192558$var$app_state.events.splice(eventIndex, 1);
        localStorage.setItem('events', JSON.stringify($ad2bcec7a0192558$var$app_state.events));
        // console.log(`Event on ${date} deleted.`);
        $ad2bcec7a0192558$var$closeModal();
    } else {
        console.error(`No event found for date: ${date}`);
        $ad2bcec7a0192558$var$closeModal();
    }
}
function $ad2bcec7a0192558$var$editEvent(date) {
    // Edit the event in localStorage
    const eventIndex = $ad2bcec7a0192558$var$app_state.events.findIndex((event)=>event.date === date.trim());
    if (eventIndex !== -1) {
        const event = $ad2bcec7a0192558$var$app_state.events[eventIndex];
        $ad2bcec7a0192558$var$eventTitleInput.value = event.title;
        $ad2bcec7a0192558$var$eventDetailsInput.value = event.details;
        $ad2bcec7a0192558$var$openModal(date);
        $ad2bcec7a0192558$var$newEventModal.style.display = 'block';
    } else {
        console.error(`No event found for date: ${date}`);
        $ad2bcec7a0192558$var$closeModal();
    }
}
function $ad2bcec7a0192558$var$load() {
    // let now = new Date(2021, 0, 1); // January 1, 2021
    let now = new Date(); // Current date
    if ($ad2bcec7a0192558$var$app_state.nav !== 0) {
        // if date is greater than the total number of days in requested month,
        // then we need to adjust the date to a smaller number. safer to just set it to 1.
        // we can do better with some more checks, but this trick works.
        if (now.getDate() > 28) now.setDate(1);
        now.setMonth(now.getMonth() + $ad2bcec7a0192558$var$app_state.nav);
    }
    $ad2bcec7a0192558$var$cleanup();
    const _day = now.getDate();
    const _month = now.getMonth();
    const _monthName = $ad2bcec7a0192558$var$months[_month];
    const _year = now.getFullYear();
    const firstDay = new Date(_year, _month, 1);
    const lastDay = new Date(_year, _month + 1, 0) // quirky!
    ;
    // go to the next month and get the 0th day, which is the last day of the previous month
    // const daysInMonth = new Date(year, month + 1, 0).getDate();
    const days = lastDay.getDate() // does the same thing as daysInMonth above
    ;
    // const day = firstDay.getDay() - 1; // no idea why i did this but it's not needed
    let date_options = {
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: 'numeric'
    };
    const dateString = now.toLocaleDateString('en-IN', date_options);
    const paddingDays = firstDay.getDay();
    for (let day of $ad2bcec7a0192558$var$weekdays){
        let weekdayBox = document.createElement('div');
        weekdayBox.classList.add('weekday');
        weekdayBox.innerText = day.substring(0, 2) // Shorten to first two letters
        ;
        weekdayBox.title = day // Full name as tooltip
        ;
        weekdayBox.style.textAlign = 'center';
        weekdayBox.style.fontWeight = 'bold';
        $ad2bcec7a0192558$var$weekdaysContainer.appendChild(weekdayBox);
    }
    for(let i = 1; i <= days + paddingDays; i++){
        let daySquare = document.createElement('div');
        const clickedDate = `${i - paddingDays}/${(_month + 1).toString().padStart(2, '0')}/${_year}`; // Month is 0-indexed
        daySquare.classList.add('day');
        if (i > paddingDays) {
            daySquare.classList.add('active');
            let currentDay;
            daySquare.innerText = currentDay = `${i - paddingDays}`;
            // console.log(`Current day: ${currentDay}, Date: ${_day}`)
            if (currentDay.toString() === _day.toString() && $ad2bcec7a0192558$var$app_state.nav === 0) {
                daySquare.id = 'today';
                daySquare.title = `Today: ${dateString}`; // Tooltip for today
            }
            const DAY_EVENT_EXISTS = $ad2bcec7a0192558$var$app_state.events.find((event)=>event.date === clickedDate);
            if (DAY_EVENT_EXISTS) {
                console.log(`Event on: ${clickedDate}`);
                const eventDiv = document.createElement('div');
                eventDiv.classList.add('event');
                eventDiv.innerText = DAY_EVENT_EXISTS.title; // Display the event title
                daySquare.appendChild(eventDiv);
                daySquare.classList.add('event_exists');
            // If an event exists for the clicked date...
            // daySquare.classList.add('event')
            }
            daySquare.addEventListener('click', (e)=>{
                $ad2bcec7a0192558$var$app_state.clicked = clickedDate; // Store the clicked date in app_state
                // console.log(`Clicked date: ${clickedDate}`);
                $ad2bcec7a0192558$var$openModal(clickedDate);
            });
        } else daySquare.classList.add('padding');
        $ad2bcec7a0192558$var$calendar.appendChild(daySquare);
    }
    $ad2bcec7a0192558$var$monthNameDisplay.innerText = `${_monthName} ${_year}`;
}
function $ad2bcec7a0192558$var$initButtons() {
    const prevMonthBtn = document.querySelector('#prevMonthBtn');
    const nextMonthBtn = document.querySelector('#nextMonthBtn');
    const currentMonthBtn = document.querySelector('#currentMonth');
    const saveEventBtn = document.querySelector('#saveEventBtn');
    const cancelEventBtn = document.querySelector('#cancelEventBtn');
    const editEventBtn = document.querySelector('#editEventBtn');
    const deleteEventBtn = document.querySelector('#deleteEventBtn');
    const closeViewEventBtn = document.querySelector('#closeViewEventBtn');
    const aboutButton = document.querySelector('#aboutButton');
    const closeAboutBtn = document.querySelector('#closeAbout');
    aboutButton.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$openAboutModal();
    });
    prevMonthBtn.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$app_state.nav--;
        $ad2bcec7a0192558$var$load();
        console.log(`Previous month button clicked, nav: ${$ad2bcec7a0192558$var$app_state.nav}`);
    });
    nextMonthBtn.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$app_state.nav++;
        $ad2bcec7a0192558$var$load();
        console.log(`Next month button clicked, nav: ${$ad2bcec7a0192558$var$app_state.nav}`);
    });
    currentMonthBtn.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$app_state.nav = 0;
        $ad2bcec7a0192558$var$load();
        console.log(`Navigating to current month, nav: ${$ad2bcec7a0192558$var$app_state.nav}`);
    });
    saveEventBtn.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$saveEvent();
        console.log('Save button clicked, event saved');
    });
    cancelEventBtn.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$closeModal();
        console.log('Cancel button clicked, modal closed');
    });
    editEventBtn.addEventListener('click', ()=>{
        // Logic to edit the event
        console.log('Edit button clicked.');
        if ($ad2bcec7a0192558$var$app_state.clicked) $ad2bcec7a0192558$var$editEvent($ad2bcec7a0192558$var$app_state.clicked);
        else console.error(`No event to edit, clicked date is null`);
        // closeModal();
        console.log('edtiting event...');
    });
    deleteEventBtn.addEventListener('click', ()=>{
        // Logic to delete the event
        console.log('Delete button clicked, deleting event...');
        if ($ad2bcec7a0192558$var$app_state.clicked) $ad2bcec7a0192558$var$deleteEvent($ad2bcec7a0192558$var$app_state.clicked);
        else console.error('No event to delete, clicked date is null');
        $ad2bcec7a0192558$var$closeModal();
        console.log('Event deleted, modal closed');
    });
    closeViewEventBtn.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$closeModal();
        console.log('Close view event button clicked, modal closed');
    });
    closeAboutBtn.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$closeAboutModal();
        console.log('Close about button clicked, about modal closed');
    });
    // default click on the modalBackdrop
    $ad2bcec7a0192558$var$backdrop.addEventListener('click', ()=>{
        $ad2bcec7a0192558$var$closeModal();
        $ad2bcec7a0192558$var$closeAboutModal();
        console.log('Backdrop clicked, modal closed');
    });
    return {
        prevMonthBtn: prevMonthBtn,
        nextMonthBtn: nextMonthBtn
    };
}
function $ad2bcec7a0192558$var$populateVersion() {
    const versionEls = document.querySelectorAll('.version_string');
    if (versionEls && versionEls.length > 0) for (const versionEl of versionEls)versionEl.textContent = versionEl.textContent.replace('#VV', (0, $bd59b245239a9d43$export$7f06b53a0b6713fe)).replace('#STABILITY', (0, $bd59b245239a9d43$export$a2da6b09a9b1a5a4));
    const title = document.title;
    if (title) document.title = title + ' v' + (0, $bd59b245239a9d43$export$7f06b53a0b6713fe);
}
document.addEventListener('DOMContentLoaded', ()=>{
    $ad2bcec7a0192558$var$sanitizeData();
    $ad2bcec7a0192558$var$populateVersion();
    $ad2bcec7a0192558$var$initButtons();
    $ad2bcec7a0192558$var$load();
});


//# sourceMappingURL=repo.a53fee97.js.map
